import { applyOverrides, counterpartyAgentCard } from '../../shared';

export const sellersAgentCard = applyOverrides(counterpartyAgentCard, {
  id: 'sellerSideContacts.sellersAgent',
  innerTitle: "Seller's Agent x",
  outerTitle: "Seller's Agents",
  addText: "Seller's Agent",
  addableTitle: "Seller's Agent x",
  legend: '* indicates a required field',
  fields: {
    firstName: {
      validation: [{ type: 'required', message: 'Required' }],
    },
    lastName: {
      validation: [{ type: 'required', message: 'Required' }],
    },
    licenseNumber: {
      validation: [
        { appliesToIndex: [0], message: 'Required', type: 'required' },
      ],
    },
    brokerageCompanyName: {
      validation: [
        { appliesToIndex: [0], message: 'Required', type: 'required' },
      ],
    },
    brokerageLicenseNumber: {
      validation: [
        { appliesToIndex: [0], message: 'Required', type: 'required' },
      ],
    },
  },
});
